"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRankDataAllOfToJSON = exports.UserRankDataAllOfFromJSONTyped = exports.UserRankDataAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
function UserRankDataAllOfFromJSON(json) {
    return UserRankDataAllOfFromJSONTyped(json, false);
}
exports.UserRankDataAllOfFromJSON = UserRankDataAllOfFromJSON;
function UserRankDataAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nickname': json['nickname'],
        'pfpUrl': !(0, runtime_1.exists)(json, 'pfpUrl') ? undefined : json['pfpUrl'],
        'level': json['level'],
        'rank': json['rank'],
        'experiencePoints': json['experiencePoints'],
    };
}
exports.UserRankDataAllOfFromJSONTyped = UserRankDataAllOfFromJSONTyped;
function UserRankDataAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nickname': value.nickname,
        'pfpUrl': value.pfpUrl,
        'level': value.level,
        'rank': value.rank,
        'experiencePoints': value.experiencePoints,
    };
}
exports.UserRankDataAllOfToJSON = UserRankDataAllOfToJSON;
